var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTaas(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32939)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#002342"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.25 7.3125H2.98012V7.99931H2.25V7.3125ZM2.98012 9.99788H5.10469V10.6875H2.25V8.68613H4.39313V9.37238H2.98069L2.98012 9.99788ZM12.8953 8.68613H15.75V10.6875H13.6069V9.99788H15.0199V9.37294H12.8953V8.68613ZM15.0317 8.0325H12.8942V7.34569H15.0317V8.0325ZM5.8005 8.68613H8.65519V10.0271H7.94419V10.6875H5.8005V8.68613ZM7.92506 9.99788V9.37294H6.53062V9.99731H7.92562L7.92506 9.99788ZM5.8005 7.3125H8.65519V7.99931H5.8005V7.3125ZM9.36337 8.68613H12.2181V10.0271H11.5071V10.6875H9.36394L9.36337 8.68613ZM11.4851 9.99788V9.37294H10.0901V9.99731L11.4851 9.99788ZM9.36337 7.3125H12.2181V7.99931H9.36337V7.3125Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32939"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaas);
export default __webpack_public_path__ + "static/media/taas.b0ca39e30317404af713a7779f043ec4.svg";
export { ForwardRef as ReactComponent };